import * as exchangeRateReducer from '../../redux/modules/exchangeRate';

const mapStateToProps = state => ({
  exchangeRate: state.exchangeRate,
});

const mapDispatchToProps = {
  ...exchangeRateReducer
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/exchange-rate/index.js